import * as React from 'react'

import {
  ImageComponent as Image,
  VideoComponent as Video,
  Carousel,
} from './Media'
import { CreativeCard } from '../../interfaces/entities/cards'
import defaultThumbnail from '../../assets/images/no-IMG.png'

interface Props {
  onClick?: () => any
  data: CreativeCard
  height: number
  width: number
}

const CardMedia = (props: Props) => {
  const { data, width, height } = props

  switch (data.type) {
    case 'video':
      return (
        <Video
          thumbnail={data.thumbnail.source}
          width={width}
          height={height}
          onClick={props.onClick}
        />
      )
    case 'image':
      return (
        <Image
          onClick={props.onClick}
          src={data.image.source}
          width={width}
          height={height}
        />
      )
    case 'carousel':
      if (data.assets.length === 0) {
        return (
          <Image
            onClick={props.onClick}
            src={defaultThumbnail}
            width={width}
            height={height}
          />
        )
      }

      return (
        <Carousel
          onAssetClick={props.onClick}
          assets={data.assets}
          width={width}
          height={height}
        />
      )
  }
  return null
}

export default CardMedia
